import { render } from "./CreateEdit.vue?vue&type=template&id=4b4365c5"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__